export default "__VITE_ASSET__DcwqXwsn__"